module.exports = __webpack_public_path__ + "img/MATIC.1ee4a1ab.png";